import { createFormAction } from "redux-form-saga";
export const FORM_KEY = "MATERIAL_FORM";
export const MaterialFormAction = createFormAction(FORM_KEY);
